import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    text: {
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        fontSize: 18,
        paddingVertical: 18
    },
    expandTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.primaryLinkColor,
        textDecorationLine: 'none'
    },
    condenseTextTitle: {
        fontFamily: Theme.regularFont,
        fontSize: 18,
        color: Theme.primaryLinkColor,
        textDecorationLine: 'none'
    }
};

export default StyleSheet.create(baseStyles);
